<div class="content">
  <automata-automation-replacement-chips
    label="AUTOMATIONS.EDITOR.TASKS.CAMPAIGNS.COMMON.CAMPAIGN"
    hint="AUTOMATIONS.EDITOR.TASKS.CAMPAIGNS.PAUSE_CAMPAIGN.DESCRIPTION"
    [dataService]="campaignSelectorService"
    [formControl]="campaignIdControl"
    [supportDataPassing]="false"
    [isRequired]="(isNonPartnerAutomation$ | async) === false"
    [multiple]="false"
    (finishedInitialLoading)="finishedLoadingSelector()"
  ></automata-automation-replacement-chips>
</div>
